import { PublicRecordModel } from '../components/common/public-record/model/public-record-model.interface';
import { ComponentList } from './components.enum';
import { UIConfigStyle } from '@cv-invision/core';

export class CvLayoutRenderModel {
	items: any[]; // need model @section.compoentn@13 & order.view@185
	schema: string;
	extraData: CvLayoutRenderExtraDataModel;
	[extraOption: string]: any;
}

export class CvLayoutRenderExtraDataModel {
	viewRules?: boolean; // ToDo: move into an Object
	isEditing?: boolean;
	publicRecord?: PublicRecordModel;
	publicRecordAddress?: any;
	permissions?: CvLayoutRenderExtraDataPermissionsModel;
	[extraOption: string]: any;

	constructor() {
		this.viewRules = false; // ToDo: stop using this value in favor of @see CvLayoutRenderExtraDataPermissionsModel
		this.isEditing = false;
		this.permissions = new CvLayoutRenderExtraDataPermissionsModel();
	}
}

export class CvLayoutRenderExtraDataPermissionsModel {
	viewRules?: boolean;
	viewGseFields?: boolean;
	viewGeneralData?: boolean;
	viewPropertyDataCollector?: boolean;

	constructor() {
		this.viewRules = false;
		this.viewGseFields = false;
		this.viewGeneralData = false;
		this.viewPropertyDataCollector = false;
	}
}

export class LayoutRenderSchemaData {
	layout: any;
	components: any;

	constructor() {
		this.layout = {};
		this.components = {};
	}
}

// Models for Layout files
export class LayoutRenderLayoutItem {
	type: string;
	title?: string;
	options?: LayoutRenderLayoutItemOptions;
	items?: LayoutRenderLayoutItem[];
	widget?: any; // Angular Component already initialized (class)
	uiConfig?: UIConfigStyle;
	// To be able to maybe pass on the Layout or controlled by the component
	permissionToRender?: boolean

	constructor() {
		this.type = 'room-layout';
		this.options = new LayoutRenderLayoutItemOptions();
		this.items = [];
	}
}

export class LayoutRenderLayoutItemOptions {
	outerCssClass?: string;
	cssClass?: string;
	key?: string;
	filterSmartTagOptions? : any;

	constructor() {
		this.outerCssClass = 'col';
		this.cssClass = '';
		this.key = null;
	}
}

/**
 * Internal Component Broadcast
 */
export class LayoutComponentBroadcast {
	public eventType: string;
	public jsonPath: string;
	public metaData?: any;
	public section?: string;
	public component?: typeof ComponentList[keyof typeof ComponentList];

	constructor() {
		this.jsonPath = null;
		this.metaData = null;
	}
}
